import { RandomId, StringHelper } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { Dropdown, RadioButtons } from "@swivl-mono/ui";
import _ from "lodash";
import React from "react";

import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import { TagInput, TagInputType } from "../../../../../Components/TagInput/TagInput";
import VarsModel from "../../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const Save = {
  Type: "save",
  Empty: function () {
    return {
      id: RandomId(6),
      type: Save.Type,

      variables: [
        {
          id: RandomId(6),
          value: "#*User:LastInput*#",
          variableId: undefined,
        },
      ],
      // "saveValue": "#*lastUserInput*#",
      // "saveValueName":"Last User Input",
      // "saveToName":"UNSET",
      // "saveTo": "",
      // "variablesTitle":[{"title":"Last User Input > Not Set"}],
      onCompleteGoto: null,
    };
  },

  PlumbData: function (node: NodeInterface) {
    let title = "",
      actionTitle = "";

    //   if (node.variablesTitle) {
    //       title = node.variablesTitle
    //     } else if (node.variables) {
    //       for (let i = 0; i < node.variables.length; i++) {

    //         const variable = node.variables[i];
    //         const saveToText =  (variable.variableId && variable.variableId.length) ? "#*" + variable.variableId + "*#" : "Not Set"

    //         if (node.action === "delete") {
    //           title += saveToText + " _!!!_";
    //         } else {
    //           const value = (variable.value && variable.value.length) ? variable.value : " Unset";
    //           title += value  + " > " + saveToText + " _!!!_";
    //         }

    //       }
    //       variablesTitle = VarsModel.replaceVariableNameInString(title).split("_!!!_").map(item=>{return {title:item}})
    // } else if (node.saveValueName || node.saveToName) {
    //   variablesTitle =  node.saveValueName  + " > " + node.saveToName;
    // }
    actionTitle = node.action === "delete" ? "Clear" : "Save";

    let bodyText: any = [];

    if (node.action === "delete") {
      bodyText = node.variables
        ? node.variables.map((item) => {
            const variable = item.variableId && item.variableId.length ? "#*" + item.variableId + "*#" : "Unset";
            return StringHelper.trimStringToLengthWithElipsis(VarsModel.replaceVariableNameInString(variable), 20);
          })
        : []; //.join("\n")
    }
    if (node.action === "special") {
      bodyText =
        node.speicalSaveVariableId && node.speicalSaveVariableId.length
          ? [StringHelper.trimStringToLengthWithElipsis(VarsModel.replaceVariableNameInString("#*" + node.speicalSaveVariableId + "*#"), 15)]
          : ["Unset"];
      actionTitle = "Save Special";
    } else {
      bodyText = node.variables
        ? node.variables.map((item) => {
            const value = item.value && item.value.length ? item.value : " Unset";
            const variable = item.variableId && item.variableId.length ? "#*" + item.variableId + "*#" : "Unset";
            return StringHelper.trimStringToLengthWithElipsis(VarsModel.replaceVariableNameInString(value + " > " + variable), 15);
          })
        : []; //.join("\n")
    }

    return TabNodeLayoutData({
      node: node,
      label: actionTitle,
      body: bodyText.join("\n"),
      bodyHeight: bodyText.length * 20,
      baseWidth: 150,
      tabs: [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto }],
    });
  },

  SaveItem: class SaveItem extends React.Component<any> {
    constructor(props: any) {
      super(props);
      this.removeClicked = this.removeClicked.bind(this);
    }
    removeClicked() {
      this.props.deleteValue("variables", this.props.index);
    }
    render() {
      const { item, index, canDelete, isClear } = this.props;
      const removeButton = canDelete ? (
        <a className="remove" onClick={this.removeClicked}>
          remove
        </a>
      ) : null;

      return (
        <div className="saveValue" key={item.id}>
          <label>
            {isClear ? "Clear" : "Save"} {removeButton}
          </label>
          {!isClear && (
            <>
              <TagInput
                type={TagInputType.SingleLine}
                value={this.props.node.variables[index].value}
                onChange={this.props.onChange}
                name={"variables." + index + ".value"}
              />
              <label>To</label>
            </>
          )}

          <UserVariablesDropdown
            onChange={this.props.onChange}
            skipUserId={true}
            name={"variables." + index + ".variableId"}
            value={this.props.node.variables[index].variableId}
          />
        </div>
      );
    }
  },

  InspectorPanel: class SaveInspectorPanel extends NodePanel {
    constructor(props) {
      super(props);

      this.addVariable = this.addVariable.bind(this);
      this.customOnChangeUpdateAndRedraw = this.customOnChangeUpdateAndRedraw.bind(this);
    }

    addVariable() {
      let varData = {
        id: RandomId(6),
        value: "",
        variableId: undefined,
      };
      this.addItemToArray(varData, "variables", true);
    }
    customOnChangeUpdateAndRedraw(event: any) {
      if (!this.props.canEdit) {
        return;
      }

      const target = event.target;
      const value = target.type === "checkbox" ? target.checked : target.value;
      const name = target.name;
      let node = JSON.parse(JSON.stringify(this.props.node));

      if (value === "special") {
        node.variables = [];
        node.specialSaveType = "date";
        node.speicalSaveVariableId = "";
      } else {
        delete node.specialSaveType;
        delete node.speicalSaveVariableId;
      }
      _.set(node, name, value);
      this.props.updateNode(node, this.props.node, true);
    }

    render() {
      const { node } = this.props;
      if (node && node.variablesTitle) {
        console.warn("delete node.variablesTitle");
        delete node.variablesTitle;
      }
      let saveVariables;
      if (node.variables) {
        const canDelete = node.variables.length > 1;
        saveVariables = node.variables.map((item, index) => (
          <Save.SaveItem
            isClear={node.action === "delete"}
            canDelete={canDelete}
            deleteValue={this.deleteValue}
            key={item.id}
            item={item}
            onChange={this.onChange}
            index={index}
            node={node}
          />
        ));
      }
      return (
        <div className="panel save_panel">
          <InspectorNodeHeader title="Save" id={this.props.node.id} />
          <label>Select an action</label>
          <RadioButtons
            options={[
              { value: "save", label: "Save" },
              { value: "delete", label: "Clear" },
              { value: "special", label: "Special" },
            ]}
            name="action"
            value={this.props.node.action || "save"}
            onChange={this.customOnChangeUpdateAndRedraw}
          />

          <br />

          {node.action === "special" ? (
            <div>
              <Dropdown
                name="specialSave"
                value={node.specialSaveType}
                onChange={this.onChange}
                options={[{ value: "date", label: "Todays Date YYYY-MM-DD" }]}
              />
              Special
              <UserVariablesDropdown
                onChange={this.onChange}
                skipUserId={true}
                name={"speicalSaveVariableId"}
                value={this.props.node.speicalSaveVariableId}
              />
            </div>
          ) : (
            <>
              {saveVariables}
              <div className="addElementButton" onClick={this.addVariable}>
                + ADD VARIABLE
              </div>
            </>
          )}

          <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
        </div>
      );
    }
  },
};
export default Save;
